import { useEffect, useState } from "react";
import bot from '../images/happy.png';
import you from '../images/boy.png';
import LoadingDots from "./LoadingDots";
import PropertyType from "./PropertyType";

const ContactUs = () => {
  const [time] = useState(new Date());
  const [time1] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [showFrame1, setShowFrame1] = useState(false);
  const [showFrame3, setShowFrame3] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleShowFrame1 = () => {
    setShowFrame1(true);
    setShowFrame3(false);
  };

  const handleShowFrame2 = () => {
    setShowFrame3(true);
    setShowFrame1(false);
  };

  return (
    <>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time.toLocaleTimeString()}
      </div>

      <div className="you-message">
        <div className="frame2">Contact Us</div>
      </div>

      <div className='chatbot'>
        <img src={bot} alt="bot" className="bot" />
        <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
      </div>

      <div>
        {loading ? (
          <div className="frame1"><LoadingDots /></div>
        ) : (
          <>
            <div className="frame1">
              <b>Akaay Infra:</b> You can contact us on: <br />
              Phone: +91 9550956767<br />
              Email: support.ind@akaaycg.com
            </div>

            <div className="frame1">
              Thank you! Is there anything else I can help you with?
              <div className="call-btns">
                <button onClick={handleShowFrame1}>Yes, start over.</button>
                <button onClick={handleShowFrame2}>No, I found what I needed.</button>
              </div>
            </div>
          </>
        )}
      </div>

      {showFrame1 && (
        <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2"><b>Start Over</b></div>
          </div>
          <PropertyType />
        </>
      )}

      {showFrame3 && (
        <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2"><b>I found what I need</b></div>
          </div>
          <div className="chatbot">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time">{time.toLocaleTimeString()}</div>
          </div>
          <div className="frame1">
            Thank you for chatting with us today!
          </div>
        </>
      )}
    </>
  );
};

export default ContactUs;
